import { makeObservable, makeAutoObservable, observable, runInAction, action } from 'mobx';
import { UserService } from '../services/userServices'
import { LoginService } from '../services/loginServices'
import { makePersistable, stopPersisting } from 'mobx-persist-store';
import { useTranslation, Trans } from "react-i18next";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import i18n from 'i18next';


const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);



export default class LoginStore {
    
    rootStore;    
    accountInfo = {};

    constructor(rootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
        makePersistable(this, { name: 'loginStore', properties: ['accountInfo'], storage: window.localStorage });
    }

    setAccountInfo = (i) => {
        this.accountInfo = i;
        i18n.changeLanguage(i?.language ?? "fr");
    };

    isLoggedIn = () => {    
        //alert(this.token)
        return this.accountInfo?.token;
    }

    logout = async () => {
        const data = await LoginService.logout();

        /*localStorage.removeItem("timesheetList_month");*/
        localStorage.removeItem("date_current");
        runInAction(() => this.reset());
        //stopPersisting(this);
    }

    reset = () => {        
        this.accountInfo = {};
        window.location.reload();
    }

    resetFrom2FA = () => {
        this.accountInfo = {};
    }

    validateCode = async (token, code) => {
        try {
            const data = await LoginService.validateCode(code, token);
            //console.log(data);
            runInAction(() => { this.setAccountInfo(data) });
        } catch (error) {
            //alert("aepepap")
            throw "Error"
        }
    }
    login = async (credentials) => {
        try {
            const data = await LoginService.login(credentials);
            runInAction(() => { /*console.log(data);*/this.setAccountInfo(data) });
        } catch (error) {
        }
    }

    changeSession = async (userId) => {
        try {
            const data = await LoginService.changeSession(userId);
            runInAction(() => {
                this.setAccountInfo(data);
                //onSuccess?.(); 
            });
        } catch (error) {
        }
    }
}